import fetch from "../fetch";

export default ({ id }) => fetch({ path: `/em/entities/${id}/check` });